import { axiosPrivateInstance } from 'libs/axios';
import { UPDATE_WEBLINK_REJECT_STATUS } from 'utils/serviceUrls';

const updateReturnedWeblinkStatusService = async (
	id: any,
	message: any,
	isProductUpdate: number,
	type: number,
) => {
	const paramData = {
		encId: id,
		comment: message,
		workFlowTypeId: isProductUpdate,
		typeId: type,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(UPDATE_WEBLINK_REJECT_STATUS, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default updateReturnedWeblinkStatusService;
